<template>
  <div class="about-us">
    <div class="header-bottom">
      <div class="line-style">
        <span class="dot"></span>
        <span class="lines"></span>
      </div>
      <div class="font-size">
        <div class="text">{{contentText.aboutUs&&contentText.aboutUs.aboutUsText}}</div>
        <div class="letter">{{contentText.aboutUs&&contentText.aboutUs.aboutUsLatter}}</div>
      </div>
      <div class="line-style">
        <span class="lines"></span>
        <span class="dot"></span>
      </div>
    </div>
    <div class="introduce-main">
      <div class="overly"></div>
      <div class="item item1">
      </div>
      <div class="item item2">

      </div>
      <div class="item item3">

      </div>
      <div class="intorduce-content">
        <div class="content-title">
          <div>大单广告</div>
          <div style="font-size: 40px;margin-top: 20px;">车身上的广告专家</div>
          <div style="font-size: 40px;">Advertising experts on the vehicle</div>
        </div>
        <div class="content-items">大单广告是大单广告（深圳）有限公司旗下的一个业务类型，将物流车身转化为广告投放媒介，不仅能够有效利用原本未被开发的资源，还能为品牌带来意想不到的曝光效果。物流车身广告具有覆盖范围广、传播频率高、成本相对较低的特点。一辆货车每日行驶里程长，途经区域多样，能够触达不同层次的受众群体。尤其是跨省、跨区域的物流车辆，其广告内容可以伴随货物一路传播，实现从一线城市到县乡市场的全面渗透。车身广告设计灵活，可结合品牌形象进行创意呈现，视觉效果突出。相比于传统静态广告，动态的物流车身广告更易吸引路人目光，增强品牌记忆点，实现资源的高效利用。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['contentText'],
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.about-us {
  .header-bottom {
    width: 100%;
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient( 180deg, #E3B26B 0%, #9C6210 100%);
    margin-top: 48px;
    margin-bottom: 20px;

    .line-style {
      height: 10px;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        background: #ffffff;
        opacity: 1;
      }
      .dot {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
      .lines {
        width: 447px;
        height: 1px;
      }
    }
    .font-size {
      margin: 0 20px;
      .text,
      .letter {
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      .text {
        font-size: 48px;
      }
      .letter {
        font-size: 24px;
      }
    }
  }
  .introduce-main {
    width: 100%;
    display: flex;
    align-items: center;
    height: 650px;
    position: relative;
    .overly {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      background-color: #7B7B7B;
      opacity: 0.7;
    }
    .intorduce-content {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .content-title {
        font-size: 60px;
        color: #ffffff;
        margin-bottom: 30px;
      }
      .content-items {
        width: 1200px;
        color: #ffffff;
        font-size: 28px;
        text-align: left;
        margin-bottom: 40px;
        line-height: 42px;
      }
    }
    .item {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .item1 {
      background: url('../../assets/homepages/grid01.png');
      background-size: 100% 100%;
    }
    .item2 {
      background: url('../../assets/homepages/grid02.png');
      background-size: 100% 100%;
    }
    .item3 {
      background: url('../../assets/homepages/grid03.png');
      background-size: 100% 100%;
    }
    .item-height {
      display: flex;
      align-items: center;
      flex-direction: column;
      min-height: 320px;
      max-height: 500px;
      overflow: hidden;
      .item-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
      .item-content {
        width: 350px;
        font-size: 16px;
        text-align: justify;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
      }
    }
  }
  .scope-of-services {
    background: #f5f5f5;
    // height: 223px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .server-title {
      width: 1192px;
      text-align: left;
      span {
        display: inline-block;
      }
      .text-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 500;
        color: #f1bc3f;
      }
      .latter-title {
        margin-left: 10px;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #acacac;
      }
    }
    .server-contetn {
      margin-top: 25px;
      width: 1192px;
      text-align: justify;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #7b7b7b;
    }
  }
}
</style>